"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GooglePublisherTagWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGpt = require("@atmedia/react-gpt");
var _healthCheck = require("./healthCheck");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_reactGpt.Bling.enableSingleRequest();
var GooglePublisherTagWrapper = exports.GooglePublisherTagWrapper = function GooglePublisherTagWrapper(_ref) {
  var adPath = _ref.adPath,
    sizeMapping = _ref.sizeMapping,
    id = _ref.id,
    style = _ref.style;
  return (0, _healthCheck.getIsBootstrapSuccess)() && /*#__PURE__*/_react.default.createElement(_reactGpt.Bling, {
    collapseEmptyDiv: true,
    adUnitPath: adPath,
    id: id,
    sizeMapping: sizeMapping,
    style: style
  });
};
GooglePublisherTagWrapper.propTypes = {
  adPath: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  sizeMapping: _propTypes.default.arrayOf(_propTypes.default.shape({
    viewport: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
    slot: _propTypes.default.arrayOf(_propTypes.default.number).isRequired
  }).isRequired).isRequired,
  style: _propTypes.default.object
};